export default __webpack_public_path__ + "static/gantmodern-medium-bc972a77506804c01f68596d6c120190.woff2";